import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import { sunoTheme } from "app/themes";

export default function MessageLabelWithWarning() {
  return (
    <Box display="inline-flex" alignItems="baseline" gap={0.5}>
      <Typography
        sx={{
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.7,
          position: "unset",
          paddingBottom: sunoTheme.typography.pxToRem(6),
          transform: "none",
          "& +.MuiInputBase-root": {
            marginTop: 0
          }
        }}
      >
        Message *
      </Typography>
      <Typography
        sx={{
          color: grey[700]
        }}
      >
        (This is the message that will be automatically sent to the patient)
      </Typography>
    </Box>
  );
}
